import React from 'react';
import { Container } from 'react-bootstrap';
import './HomeBlog.css';


const HomeBlog = ({ homeBlog}) => {
      
  const { name, img, discretion, myBlog} = homeBlog;

return ( 
  <div className='mb-5'>   
      <Container>
        <div className="homeBlog">
            <div className="homeBlog-img">
                <img src={img} alt="" />
            </div>
            <div className='homeBlog-text mt-3'>
              <h3>{name}</h3>
              <h6 className='my-3'>{discretion}</h6>
              <a href={myBlog}><button>SEE MORE</button></a>
            </div>
        </div>
      </Container>

</div>                   
                  
);
  };
  
export default HomeBlog;                  
                     
                  
             
